import React from 'react';
import FeatureRichList from '../Common/RichList/FeatureRichList';


export const registerLoginSteps = [
    {
        id: 0,
        title: 'Tải ứng dụng miễn phí bằng cách tìm kiếm từ khóa "GooPay" trên Apple Store hoặc Google Play',
    },
    {
        id: 1,
        title: 'Mở ứng dụng GooPay và chọn "Đăng ký/ Đăng nhập"',
        subtitle: ['Nhập số điện thoại và xác nhận mã OTP gửi qua tin nhắn'],
    },
    {id: 2, title: 'Tạo mật khẩu'},
    {id: 3, title: 'Điền thông tin cá nhân'},
    {id: 4, title: 'Đăng ký thành công và bắt đầu sử dụng'},
];

const RegisterLoginContent = ({setStep, step}) => {
    return (
        <div className="w-full max-w-4xl mx-auto py-4 px-2 md:px-4 flex justify-center">
             <FeatureRichList data={registerLoginSteps} step={step} setStep={setStep} subClass='subClass'/>
        </div>
    );
};

export default RegisterLoginContent;
